import { ChainBaseEventMetadata } from '../asset';
import {
  ApplicationData,
  AttachmentData,
  CreateAttachmentInputData,
  DeviceData,
  EventData,
  GeolocationData,
  RootEventData,
  SubjectData,
  SubjectDataReferenceItem,
} from '../common';

export interface CheckInEventInput {
  application: ApplicationData;
  rootEvent: RootEventData;
  subject: SubjectData;
  device: DeviceData;
  data: {
    date: string;
    geolocation: GeolocationData;
    attachments: CreateAttachmentInputData[];
  };
  event: EventData;
}

export interface CheckInEvent {
  id: string;
  eventType: string;
  application: string;
  device: DeviceData;
  status: string;
  subjectType: string;
  attachments: AttachmentData[];
  eventDate?: string;
  subjectReferences: SubjectDataReferenceItem[];
  properties?: CheckInProperty[];
  metadata?: Partial<ChainBaseEventMetadata>;
}

export interface CheckInProperty {
  id: string;
  name: string;
  value: string;
}

export enum VerificationTypeEnum {
  Reject = 'Reject',
  Official = 'Official',
  Witness = 'Witness',
  Buyer = 'Buyer',
  Seller = 'Seller',
  Review = 'Review',
  Inspection = 'Inspection',
  Archive = 'Archive',
}
